import {  faTrash } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { DeletarTipoParcelaController } from "../../../../Controllers/Cobranca/TipoParcela/TipoParcelaController";

interface IExcluirTipoParcelaProps{
    disableTooltip?: boolean,
    ID_TIPO_PARCELA: number,
    then: () => void
}

export default function ExcluirTipoParcela(props: IExcluirTipoParcelaProps){

    function onButtonClick(){
        DeletarTipoParcelaController(props.ID_TIPO_PARCELA)
        .then(props.then);
    }

    return (
        <button 
            type="button" 
            className="btn btn-outline-danger font-weight-bold mr-2"
            onClick={onButtonClick}
        >
            <FontAwesomeIcon size="lg" icon={faTrash}/> Excluir
        </button>
    )
}